<template>
  <section class="d-sm-flex align-self-center text-dark bg-light py-4 px-5 mt-5 mb-5 flex-column d-xs-block">
    <div class="row">
      <div class="flex-md-row flex-xxs-column d-md-flex d-sm-block col-sm-12 col-md-9 p-0">
        <img
          :src="fileUrl(product.icon)"
          :alt="product.name"
          width="200"
          height="200"
          itemprop="logo"
          style="min-width: 200px"
        >
        <div class="d-flex flex-column mx-md-4 mx-xxs-1">
          <h1 itemprop="name">
            {{ product.name }}
          </h1>
          <h3 class="my-3">
            {{ product.publisher.name }}
          </h3>
          <span>
            <b-link class="text-success mt-2 text-decoration-none" href="#" @click="copyToClipboard">
              <img height="20" class="text-success" src="@/assets/icons/share.svg">
              <small class="mx-2" itemprop="url">
                {{ $t('product.shareThisProduct', {product: this.globalResources.productTranslation.Single}) }}
              </small>
            </b-link>
          </span>
          <p
            v-if="product.description"
            class="d-flex mt-5 product-description"
            itemprop="description"
            v-html="product.description"
          />
        </div>
      </div>
      <!--  -->
      <div class="d-flex flex-column col-md-3 col-sm-12 p-0" itemscope itemtype="http://schema.org/MediaObject">
        <ProductDownload :product="product" />
        <span v-if="product.type === 'AndroidGame'" class="mt-3">
          {{ $t('product.fileSize') }}
          <span itemprop="contentSize" class="px-1">
            {{ size }}
          </span>
        </span>
        <div class="d-flex flex-column mt-xxs-3">
          <ProductCollections :product="product" />
          <ProductGenres :product="product" />
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import ProductCollections from '@/components/ProductCollections.vue'
import ProductGenres from '@/components/ProductGenres.vue'
import ProductDownload from '@/components/ProductDownload.vue'

export default {
  name: 'MusicSummary',
  components: {
    ProductCollections,
    ProductGenres,
    ProductDownload
  },
  props: {
    product: {
      type: Object,
      default: () => {}
    }
  },
  data () {
    return {
      playMusic: false,
      musicUrl: ''
    }
  },
  computed: {
    ...mapGetters({
      fileUrl: 'cdn/fileUrl',
      tenantInfo: 'tenantConfig/tenantInfo',
      tenantDesignInfo: 'tenantDesign/config',
      isUserAuthenticated: 'auth/isUserAuthenticated'
    }),
    size () {
      let size = this.product.size
      if (size < 1024) {
        return size + this.$t('common.byte')
      } else if (size < 1024 * 1024) {
        return Math.round((size / 1024) * 1000) / 1000 + this.$t('common.kb')
      } else if (size < 1024 * 1024 * 1024) {
        return (
          Math.round((size / (1024 * 1024)) * 1000) / 1000 +
          this.$t('common.mb')
        )
      } else if (size < 1024 * 1024 * 1024 * 1024) {
        return (
          Math.round((size / (1024 * 1024 * 1024)) * 1000) / 1000 +
          this.$t('common.gb')
        )
      } else {
        return ''
      }
    },
    downloadButtonText () {
      switch (this.product.type) {
        case 'HtmlGame':
          return this.$t('product.play', { product: this.globalResources.productTranslation.Single })
        case 'AndroidGame':
          return this.$t('product.download')
        case 'AudioBook':
          return this.$t('product.download')
        default:
          return ''
      }
    }
  },
  methods: {
    ...mapActions({
      getProductUrl: 'productCatalog/getProductUrl',
      getDownloadToken: 'productCatalog/getDownloadToken'
    }),
    download () {
      this.$emit('download')
    },
    getMusicFromServer () {
      this.getProductUrl(this.product.id).then(result => {
        let payload = {
          url: result.body.result,
          productId: this.product.id,
          tenantId: this.tenantInfo.id
        }
        this.getDownloadToken(payload).then((response) => {
          let downloadUrl = this.tenantDesignInfo.general.cdn2Address + '/cdn/download/ticket/' + response.body.result
          // TODO: use fileUrl to generate correct file url
          this.musicUrl = downloadUrl
          this.playMusic = true
        })
      })
    },
    copyToClipboard () {
      var dummy = document.createElement('input')

      var text = window.location.href
      document.body.appendChild(dummy)
      dummy.value = text
      dummy.select()
      try {
        var successful = document.execCommand('copy')
        dummy.remove()
        alert(this.$t('product.productUrlCopiedToClipboard', { product: this.globalResources.productTranslation.Single }))
      } catch (err) {
        alert(this.$t('product.productUrlDoesNotCopiedToClipboard', { product: this.globalResources.productTranslation.Single }))
      }
    }
  }
}
</script>
